export const CREATE_PATTERN_REQUEST = "CREATE_PATTERN_REQUEST";
export const CREATE_PATTERN_SUCCESS = "CREATE_PATTERN_SUCCESS";
export const CREATE_PATTERN_FAIL = "CREATE_PATTERN_FAIL";
export const CREATE_PATTERN_RESET = "CREATE_PATTERN_RESET";

export const GET_ALL_PATTERNS_REQUEST = "GET_ALL_PATTERNS_REQUEST";
export const GET_ALL_PATTERNS_SUCCESS = "GET_ALL_PATTERNS_SUCCESS";
export const GET_ALL_PATTERNS_FAIL = "GET_ALL_PATTERNS_FAIL";

export const GET_USERS_PATTERNS_REQUEST = "GET_USERS_PATTERNS_REQUEST";
export const GET_USERS_PATTERNS_SUCCESS = "GET_USERS_PATTERNS_SUCCESS";
export const GET_USERS_PATTERNS_FAIL = "GET_USERS_PATTERNS_FAIL";

export const GET_PATTERN_REQUEST = "GET_PATTERN_REQUEST";
export const GET_PATTERN_SUCCESS = "GET_PATTERN_SUCCESS";
export const GET_PATTERN_FAIL = "GET_PATTERN_FAIL";

export const REMOVE_PATTERN_REQUEST = "REMOVE_PATTERN_REQUEST";
export const REMOVE_PATTERN_SUCCESS = "REMOVE_PATTERN_SUCCESS";
export const REMOVE_PATTERN_FAIL = "REMOVE_PATTERN_FAIL";

export const UPDATE_PATTERN_REQUEST = "UPDATE_PATTERN_REQUEST";
export const UPDATE_PATTERN_SUCCESS = "UPDATE_PATTERN_SUCCESS";
export const UPDATE_PATTERN_FAIL = "UPDATE_PATTERN_FAIL";
export const UPDATE_PATTERN_RESET = "UPDATE_PATTERN_RESET";

export const CREATE_PATTERN_REVIEW_REQUEST = "CREATE_PATTERN_REVIEW_REQUEST";
export const CREATE_PATTERN_REVIEW_SUCCESS = "CREATE_PATTERN_REVIEW_SUCCESS";
export const CREATE_PATTERN_REVIEW_FAIL = "CREATE_PATTERN_REVIEW_FAIL";
export const CREATE_PATTERN_REVIEW_RESET = "CREATE_PATTERN_REVIEW_RESET";
